var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex-checkbox",
    class: {
      disabled: _vm.disabled
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.updateValue.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "c-checkbox",
    class: {
      'active-checkbox': _vm.isActive
    }
  }, [_vm.isActive ? _c('svg', {
    staticClass: "transform origin-center",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5 13l4 4L19 7"
    }
  })]) : _vm._e()]), _c('span', [_vm._v(_vm._s(_vm.label))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }